import React from "react";

import "./index.scss";

const SmartInsightsIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="27.529" viewBox="0 0 31 27.529" className="insight-icon">
    <g id="Icon" transform="translate(10.899 9.678)" className={`default ${props.active ? "active" : ""}`}>
      <g id="Group_17305" data-name="Group 17305" transform="translate(-10.899 -9.678)">
        <rect
          id="Rectangle_7021"
          data-name="Rectangle 7021"
          className="insight-cls-1"
          width="21.114"
          height="17.947"
          transform="translate(4.943 4.983)"
        />
        <g id="Group_17301" data-name="Group 17301" transform="translate(8.683 0)">
          <rect id="Rectangle_7022" data-name="Rectangle 7022" className="insight-cls-2" width="2.869" height="4.943" />
          <rect id="Rectangle_7023" data-name="Rectangle 7023" className="insight-cls-2" width="2.869" height="4.943" transform="translate(5.554)" />
          <rect id="Rectangle_7024" data-name="Rectangle 7024" className="insight-cls-2" width="2.869" height="4.943" transform="translate(10.764)" />
        </g>
        <g id="Group_17302" data-name="Group 17302" transform="translate(8.683 22.585)">
          <rect id="Rectangle_7025" data-name="Rectangle 7025" className="insight-cls-2" width="2.869" height="4.943" />
          <rect id="Rectangle_7026" data-name="Rectangle 7026" className="insight-cls-2" width="2.869" height="4.943" transform="translate(5.554)" />
          <rect id="Rectangle_7027" data-name="Rectangle 7027" className="insight-cls-2" width="2.869" height="4.943" transform="translate(10.764)" />
        </g>
        <g id="Group_17303" data-name="Group 17303" transform="translate(0 7.14)">
          <rect
            id="Rectangle_7028"
            data-name="Rectangle 7028"
            className="insight-cls-2"
            width="2.869"
            height="4.943"
            transform="translate(4.943 0) rotate(90)"
          />
          <rect
            id="Rectangle_7029"
            data-name="Rectangle 7029"
            className="insight-cls-2"
            width="2.869"
            height="4.943"
            transform="translate(4.943 5.554) rotate(90)"
          />
          <rect
            id="Rectangle_7030"
            data-name="Rectangle 7030"
            className="insight-cls-2"
            width="2.869"
            height="4.943"
            transform="translate(4.943 10.764) rotate(90)"
          />
        </g>
        <g id="Group_17304" data-name="Group 17304" transform="translate(26.057 7.14)">
          <rect
            id="Rectangle_7031"
            data-name="Rectangle 7031"
            className="insight-cls-2"
            width="2.869"
            height="4.943"
            transform="translate(4.943 0) rotate(90)"
          />
          <rect
            id="Rectangle_7032"
            data-name="Rectangle 7032"
            className="insight-cls-2"
            width="2.869"
            height="4.943"
            transform="translate(4.943 5.554) rotate(90)"
          />
          <rect
            id="Rectangle_7033"
            data-name="Rectangle 7033"
            className="insight-cls-2"
            width="2.869"
            height="4.943"
            transform="translate(4.943 10.764) rotate(90)"
          />
        </g>
      </g>
      <path
        id="Path_15835"
        data-name="Path 15835"
        className="insight-cls-3"
        d="M6.653,11.585H8.9L5.747,2.876H3.291L.14,11.585H2.36l.521-1.538h3.25ZM5.586,8.409H3.44L4.507,5.221Zm4.268,3.176h2.122V2.876H9.854Z"
        transform="translate(-2.163 -3.126)"
      />
    </g>
  </svg>
);

export default SmartInsightsIcon;
